import { request } from "../base";
import type { TaxonomyItem } from "../taxonomy";

export const adminTaxonomyApi = {
	async listTaxonomy(type: string, includeInactive = false) {
		const query = includeInactive ? "?includeInactive=true" : "";
		return request<TaxonomyItem[]>(`/api/admin/taxonomy/${type}${query}`);
	},

	async getTaxonomyItem(type: string, id: string) {
		return request<TaxonomyItem>(`/api/admin/taxonomy/${type}/${id}`);
	},

	async createTaxonomyItem(type: string, data: Partial<TaxonomyItem>) {
		return request<TaxonomyItem>(`/api/admin/taxonomy/${type}`, {
			method: "POST",
			body: data,
		});
	},

	async updateTaxonomyItem(
		type: string,
		id: string,
		data: Partial<TaxonomyItem>,
	) {
		return request<TaxonomyItem>(`/api/admin/taxonomy/${type}/${id}`, {
			method: "PUT",
			body: data,
		});
	},

	async deleteTaxonomyItem(type: string, id: string) {
		return request(`/api/admin/taxonomy/${type}/${id}`, {
			method: "DELETE",
		});
	},

	async reorderTaxonomy(
		type: string,
		items: Array<{ id: string; sortOrder: number }>,
	) {
		return request(`/api/admin/taxonomy/${type}/reorder`, {
			method: "PATCH",
			body: { items },
		});
	},
};
